<template>
	<page class="dashboard" title="Planlægning" style="background-color: #F0F0F0;">
		<button-group-view style="float: left;" slot="tools" :actions="[
			{
				label: 'Kanban',
				value: 'kanban'
			},
			{
				label: 'Kort',
				value: 'map'
			}
		]" v-model="view" />
		<button-view style="float: left;" slot="tools" @click="createTodo">+ Todo</button-view>
		<button-view style="float: left;" slot="tools" @click="createJob">+ Opgave</button-view>
		<button-view style="float: left;" slot="tools" @click="createCustomer">+ Kunde</button-view>
		<div class="layout">
			<date-picker-std-view v-model="date" class="date" @browse="updateState" />
			<plethora-tabs-view class="tabs" v-model="tab" :tabs="[
				{
					label: 'Opgaver',
					value: 'jobs',
					badge: {
						visible: tasks.length > 0,
						label: tasks.length
					}
				},
				{
					label: 'Todo',
					value: 'todo',
					badge: {
						visible: todos.length > 0,
						label: todos.length
					}
				}
			]" />
			<perfect-scrollbar class="tasks" name="task" tag="div" :style="{
				transition: 'grid-row 250ms'
			}">
				<transition-group name="task" tag="div">
					<task-view v-for="(task, i) in _tasks" :key="i" class="task" :task="task" />
					<todo-view v-for="(todo, i) in _todos" :key="i" class="task" :todo="todo" />
				</transition-group>
			</perfect-scrollbar>
			<kanban-view v-show="view == 'kanban'" class="list" :users="users" />
			<gmap-map ref="map" v-show="view == 'map'" class="list" :center="{lat:10, lng:10}" :zoom="7" :options="{ styles: _map_style }">
				
			</gmap-map>
		</div>
	</page>
</template>

<script>
	import NewTableView from '../views/NewTableView'
	import DatePickerStdView from '../views/DatePickerStdView'

	import todo from '../model/todo';
	import user from '../model/user';
	import job from '../model/job';
	import customer from '../model/customer';

	import { bus } from '../../bus'

    export default {
		data() {
			return {
				tab: 'jobs',
				date: (new Date()).format('Y-m-d'),
				tasks: [1, 2, 23],
				users: [],
				todos: [],
				view: 'kanban'
			};
		},
		components: {
			'NewTableView': NewTableView,
			'DatePickerStdView': DatePickerStdView
		},
		watch: {
			date(n, o) {
				this.items = null;
				this.update();
			}
		},
		computed: {
			_tasks() {
				return this.tab == 'jobs' ? this.tasks : [];
			},
			_users() {
				return this.users;
			},
			_todos() {
				return this.tab == 'todo' ? this.todos : [];
			},
			_map_style() {
				return [
					{
						"elementType": "geometry",
						"stylers": [
						{
							"color": "#f5f5f5"
						}
						]
					},
					{
						"elementType": "labels.icon",
						"stylers": [
						{
							"visibility": "off"
						}
						]
					},
					{
						"elementType": "labels.text.fill",
						"stylers": [
						{
							"color": "#616161"
						}
						]
					},
					{
						"elementType": "labels.text.stroke",
						"stylers": [
						{
							"color": "#f5f5f5"
						}
						]
					},
					{
						"featureType": "administrative.land_parcel",
						"elementType": "labels.text.fill",
						"stylers": [
						{
							"color": "#bdbdbd"
						}
						]
					},
					{
						"featureType": "poi",
						"elementType": "geometry",
						"stylers": [
						{
							"color": "#eeeeee"
						}
						]
					},
					{
						"featureType": "poi",
						"elementType": "labels.text.fill",
						"stylers": [
						{
							"color": "#757575"
						}
						]
					},
					{
						"featureType": "poi.park",
						"elementType": "geometry",
						"stylers": [
						{
							"color": "#e5e5e5"
						}
						]
					},
					{
						"featureType": "poi.park",
						"elementType": "labels.text.fill",
						"stylers": [
						{
							"color": "#9e9e9e"
						}
						]
					},
					{
						"featureType": "road",
						"elementType": "geometry",
						"stylers": [
						{
							"color": "#ffffff"
						}
						]
					},
					{
						"featureType": "road.arterial",
						"elementType": "labels.text.fill",
						"stylers": [
						{
							"color": "#757575"
						}
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "geometry",
						"stylers": [
						{
							"color": "#dadada"
						}
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "labels.text.fill",
						"stylers": [
						{
							"color": "#616161"
						}
						]
					},
					{
						"featureType": "road.local",
						"elementType": "labels.text.fill",
						"stylers": [
						{
							"color": "#9e9e9e"
						}
						]
					},
					{
						"featureType": "transit.line",
						"elementType": "geometry",
						"stylers": [
						{
							"color": "#e5e5e5"
						}
						]
					},
					{
						"featureType": "transit.station",
						"elementType": "geometry",
						"stylers": [
						{
							"color": "#eeeeee"
						}
						]
					},
					{
						"featureType": "water",
						"elementType": "geometry",
						"stylers": [
						{
							"color": "#c9c9c9"
						}
						]
					},
					{
						"featureType": "water",
						"elementType": "labels.text.fill",
						"stylers": [
						{
							"color": "#9e9e9e"
						}
						]
					}
				];
			}
		},
		methods: {
			async updateState() {

			},
			async update() {
				[ this.users, this.todos ] = (await Promise.all([
					user.search({ role_id: 'worker' }),
					todo.readOpen()
				]));
			},
			createTodo() {
				const self  = this;

				todo.open(null, () => {
					self.update();
				});
			},
			createJob() {
				job.open(null, () => {
					self.update();
				});
			},
			createCustomer() {
				customer.open(null, () => {
					self.update();
				});
			}
		},
		mounted() {
			this.update();

			const self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});

			// Map		
			this.$refs.map.$mapPromise.then((map) => {
				map.panTo({
					lat: 1.38, 
					lng: 103.80
				});
			})
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: auto auto 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
			
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px 30px 20px 30px;
	}

	.tabs {
		grid-column: 1;
		grid-row: 2;
		background-color: #f0f0f0;
		margin-left: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 3;
		background-color: #f0f0f0;		

		border-top: 1px solid #cecece;
		padding: 20px;
	}

	.list {
		grid-column: 2 / 3;
		grid-row: 1 / 4;
		border-left: 1px solid #cecece;
	}
</style>